export default __webpack_public_path__ + "static/media/almost_naked.c215f5f6.jpg";